<mp-filter-group
  [filterName]="filterName()"
  [icon]="icon()"
  [isExpanded]="isExpanded"
  (isExpandedChange)="onExpandedChange($event)"
>
  <!-- TODO Can we do it in the same if? -->
  @if (dateFrom() || dateTo()) {
    <div class="facet-selection-info truncate" filter-group-selection-info>
      <ng-container
        *ngrxLet="{
          dateFrom: (dateFrom() | date: 'dd.MM.yyyy') ?? undefined,
          dateTo: (dateTo() | date: 'dd.MM.yyyy') ?? undefined,
        } as dateRange"
      >
        <span *ngrxLet="dateRange | mpSelectedDateRange as selectedDateRange" [title]="selectedDateRange">
          {{ selectedDateRange }}
        </span>
      </ng-container>
    </div>
  }

  @if (dateFrom() || dateTo()) {
    <mp-filter-clear-button filter-group-clear-filter-action (clearFilter)="clearDateRangeSelection()" />
  }

  <div class="date-selectors">
    <mp-filter-date-selector
      [(selectedDate)]="dateFrom"
      [label]="dateFromSelectorLabel()"
      (selectedDateChange)="emitDateRangeChange()"
    />

    @if (showDateTo()) {
      <mp-filter-date-selector [(selectedDate)]="dateTo" label="bis" (selectedDateChange)="emitDateRangeChange()" />
    }
  </div>
</mp-filter-group>
